import React from "react";
import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import HomeTestimonialCard from "./HomeTestimonialCard";

const HomeTestimonialCardLayout = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile


    const testimonialData = [
        {
            image: "",
            name: "Husna",
            comments: "Terima kasih sejiwa. Design banyak cantik & mudah untuk order"

        },
        {
            image: "",
            name: "Zaki",
            comments: "Sangat berpuas hati sebab kad terus siap and order sendiri. Thank you Sejiwa"
        },
        {
            image: "",
            name: "Zul",
            comments: "Harga berpatutan, memang terbaikk. Really worth it"
        },
        {
            image: "",
            name: "Syafiqah",
            comments: "Service sangat laju dan terbaik! Design kad pun cantik & overall sangat berpuas hati"
        },
        {
            image: "",
            name: "Amin",
            comments: "Puas hati order disini, mudah and cepat"
        }



    ];

    return (

        <Box sx={{
            background: "linear-gradient(135deg, #f0fafa 0%, #e3f8f8 50%, #fdf6ff 100%)",
            position: "relative",
            overflow: "hidden",
            mt: 5,
        }}>
            {/* Blob 1 — top left */}
            <Box sx={{
                position: "absolute", width: "420px", height: "420px", borderRadius: "50%",
                background: "radial-gradient(circle, #a8ecec 0%, #55c2c3 60%, transparent 100%)",
                top: "-140px", left: "-130px", filter: "blur(80px)", opacity: 0.5, pointerEvents: "none",
            }} />
            {/* Blob 2 — bottom right */}
            <Box sx={{
                position: "absolute", width: "320px", height: "320px", borderRadius: "50%",
                background: "radial-gradient(circle, #e4b8f8 0%, #c084fc 60%, transparent 100%)",
                bottom: "-100px", right: "-80px", filter: "blur(80px)", opacity: 0.45, pointerEvents: "none",
            }} />
            {/* Blob 3 — centre accent */}
            <Box sx={{
                position: "absolute", width: "220px", height: "220px", borderRadius: "50%",
                background: "radial-gradient(circle, #fde68a 0%, #fbba72 60%, transparent 100%)",
                top: "40%", left: "50%", filter: "blur(70px)", opacity: 0.3, pointerEvents: "none",
            }} />
            <Container sx={{ textAlign: "start", mt: 5, pt: 3, pb: 3, maxWidth: "1300px", position: "relative", zIndex: 1 }}>

                <Typography variant="h6" fontWeight={600} sx={{ textAlign: "center" }}>
                    Testimonial
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ textAlign: "center" }}>
                    What our previous customer say...
                </Typography>

                {/* Mobile View - Carousel */}
                {isMobile ? (
                    <Swiper

                        modules={[Pagination]}
                        spaceBetween={10}
                        slidesPerView={isMobile ? 1 : 3}
                        pagination={{ clickable: true }}
                        style={{ paddingBottom: "25px", "--swiper-pagination-color": "#68D2D2", }}
                    >
                        {testimonialData.map((testimonial, index) => (
                            <SwiperSlide key={index} style={{ display: "flex", justifyContent: "center" }}>
                                <HomeTestimonialCard image={testimonial.image} name={testimonial.name} comments={testimonial.comments} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <Swiper

                        modules={[Pagination]}
                        spaceBetween={35}
                        slidesPerView={3}
                        pagination={{ clickable: true }}
                        style={{ paddingBottom: "50px", paddingTop: "20px", paddingRight: "10px", paddingLeft: "10px", "--swiper-pagination-color": "#68D2D2", }}
                    >
                        {testimonialData.map((testimonial, index) => (
                            <SwiperSlide key={index} style={{ display: "flex", justifyContent: "center" }}>
                                <HomeTestimonialCard image={testimonial.image} name={testimonial.name} comments={testimonial.comments} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}


            </Container>
        </Box>


    );

};

export default HomeTestimonialCardLayout;